var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('h2', [_c('strong', [_vm._v("Laba Rugi")])]), _c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mr-1",
    attrs: {
      "label": "Dari"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filter.tgl_awal,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "tgl_awal", $$v);
      },
      expression: "filter.tgl_awal"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mr-1",
    attrs: {
      "label": "Sampai"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filter.tgl_akhir,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "tgl_akhir", $$v);
      },
      expression: "filter.tgl_akhir"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "-"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.getGraphicData($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "FilterIcon"
    }
  }), _vm._v("Filter")], 1)], 1)], 1)], 1), _c('app-echart-bar', {
    attrs: {
      "optionData": _vm.profitAndLoss
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }